export default "__VITE_ASSET__kAKHRDy___"